module.exports = __webpack_public_path__ + "img/page-5-line-water@2x.9cfbd903.png";